import axios from "axios";
import { BASE_URL, IMAGE_URL, API_ORIGIN } from "../config/appUrls";

export { API_ORIGIN, IMAGE_URL, BASE_URL };

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
});

instance.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "application/json";
    const token = localStorage.getItem("kiosk_access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const detail = String(error.response?.data?.detail || "").toLowerCase();
    const code = error.response?.data?.code;
    const isAuthFailure =
      error.response?.status === 401 &&
      (code === "user_inactive" ||
        code === "invalid_token" ||
        code === "user_not_found" ||
        detail.includes("authentication failed"));

    if (isAuthFailure) {
      localStorage.removeItem("kiosk_access_token");
      localStorage.removeItem("kiosk_refresh_token");
      localStorage.removeItem("kiosk_user_id");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default instance;

export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem("kiosk_access_token", token);
    instance.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem("kiosk_access_token");
    delete instance.defaults.headers.common.Authorization;
  }
};

export const getUserProfile = () => instance.get("user-profile/");

export const kioskPunch = (employeeId, action) =>
  instance.post("attendance/kiosk/punch/", {
    employee_id: employeeId,
    action,
  });

export const getEmployeeStatus = (employeeId) =>
  instance.get("attendance/kiosk/employee-status/", {
    params: { employee_id: employeeId },
  });
